import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { HvGrid, HvInput } from "@hitachivantara/uikit-react-core";
import { HvTimePicker } from "@hitachivantara/uikit-react-lab";
import { useFormikContext } from "formik";

import useStyles from "./styles";

const FindExistingIncident: React.FC = () => {
  const classes = useStyles();

  const { t } = useTranslation("incidentDialog");

  const {
    values,
    setFieldTouched,
    setFieldValue,
    status,
    setStatus,
    errors,
    touched,
  } = useFormikContext<FindExistingIncidentFormData>();

  const { serverSideErrors = {} } = status;

  const parseStatus = (field: keyof FindExistingIncidentFormData) =>
    serverSideErrors[field] || (errors[field] && touched[field])
      ? "invalid"
      : "valid";

  const parseStatusMessage = (field: keyof FindExistingIncidentFormData) => {
    if (serverSideErrors[field]) {
      return serverSideErrors[field];
    }

    return errors[field] && touched[field] ? errors[field] : "";
  };

  const setValueOnForm = useCallback(
    (property: string, selection: unknown) => {
      setFieldTouched(property);
      setFieldValue(property, selection);
      // clearServerSideErrors
      setStatus({});
    },
    [setFieldTouched, setFieldValue, setStatus]
  );

  return (
    <>
      <HvGrid xs={12} md={6} item>
        <HvInput
          className={classes.input}
          name="name"
          label={t("sections.existingIncident.formElement.proximity.label")}
          placeholder={t(
            "sections.existingIncident.formElement.proximity.placeholder"
          )}
          inputProps={{
            autoComplete: "off",
          }}
          description={t(
            "sections.existingIncident.formElement.proximity.description"
          )}
          required={values?.timeframe as boolean}
          value={values?.proximity || ""}
          status={parseStatus("proximity")}
          statusMessage={parseStatusMessage("proximity")}
          onChange={(evt, value) => {
            setValueOnForm("proximity", value);
          }}
        />
      </HvGrid>
      <HvGrid xs={12} md={6} item>
        <HvTimePicker
          timeFormat="24"
          disableDefaultValue
          required={values?.proximity != null && values?.proximity !== ""}
          status={parseStatus("timeframe")}
          statusMessage={parseStatusMessage("timeframe")}
          label={t("sections.existingIncident.formElement.timeframe.label")}
          placeholder={t(
            "sections.existingIncident.formElement.timeframe.placeholder"
          )}
          value={values.timeframe}
          onChange={(value) => {
            setValueOnForm("timeframe", value);
          }}
          onToggle={() => {
            setFieldTouched("timeframe");
          }}
        />
      </HvGrid>
    </>
  );
};

export default FindExistingIncident;
